import { CommunicationProvider, useCommunication } from "@/lib/CommunicationWrapper";
import { DragProvider, PlannerProvider } from "./contexts/PlannerContext";
import { AssignmentsPageContent } from "./components/AssignmentsPage";
import { CalendarVars } from "./components/Calendar";
import { WithTheme } from "@/lib/WithTheme";
import { useEffect, useState, useRef } from "react";
import { FirstTimeOnboarding } from "@/src/components/FirstTimeOnboarding";
import { ASSIGNMENTS_ONBOARDING_STEPS } from "@/lib/page-onboarding";
import { AssignmentTypesProvider } from "@/lib/AssignmentTypesContext";

const AssignmentsPageInner = () => {
    const { getOptions, updateOptions } = useCommunication();
    const [showOnboarding, setShowOnboarding] = useState(false);
    const [portalElement, setPortalElement] = useState<HTMLDivElement | null>(null);
    const hasCheckedOnboarding = useRef(false);

    useEffect(() => {
        if (hasCheckedOnboarding.current) return;
        hasCheckedOnboarding.current = true;

        const options = getOptions();
        if (!options.assignments_onboarding_viewed) {
            setShowOnboarding(true);
        }
    }, [getOptions]);

    const handleOnboardingComplete = () => {
        updateOptions({ assignments_onboarding_viewed: true });
        setShowOnboarding(false);
    };

    const handleOnboardingSkip = () => {
        updateOptions({ assignments_onboarding_viewed: true });
        setShowOnboarding(false);
    };

    return (
        <>
            <div className="fixed top-0 left-0 z-[100000000000000]" ref={setPortalElement} />
            <PlannerProvider>
                <DragProvider>
                    <AssignmentTypesProvider>
                        <CalendarVars />
                        <AssignmentsPageContent />
                        <FirstTimeOnboarding
                            isOpen={showOnboarding}
                            onComplete={handleOnboardingComplete}
                            onSkip={handleOnboardingSkip}
                            steps={ASSIGNMENTS_ONBOARDING_STEPS}
                            container={portalElement}
                        />
                    </AssignmentTypesProvider>
                </DragProvider>
            </PlannerProvider>
        </>
    );
};

export const AssignmentsPage = () => {
    return (
        <CommunicationProvider requiresLocalStorage={true}>
            <WithTheme />
            <AssignmentsPageInner />
        </CommunicationProvider>
    )
}

export default AssignmentsPage;